export function convertStringDateToDate(date: string) {
  const dateValues = date.includes("/") ? date.split("/") : date.split("-");

  const year = parseInt(dateValues[0].length > 2 ? dateValues[0] : dateValues[2]);
  const day = parseInt(dateValues[0].length > 2 ? dateValues[2] : dateValues[0]);
  const month = parseInt(dateValues[1]) - 1;

  return new Date(year, month, day);
}

export function getDateOnly(date: string | Date) {
  if (typeof date === "string")
    date = new Date(date);

  return date.toISOString().split('T')[0]
}